import { render, staticRenderFns } from "./controlltower.vue?vue&type=template&id=faeb4d1e&scoped=true"
import script from "./controlltower.vue?vue&type=script&lang=js"
export * from "./controlltower.vue?vue&type=script&lang=js"
import style0 from "./controlltower.vue?vue&type=style&index=0&id=faeb4d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeb4d1e",
  null
  
)

export default component.exports